import { WebPlugin } from '@capacitor/core';
export class SplashScreenWeb extends WebPlugin {
    async show(_options) {
        return undefined;
    }
    async hide(_options) {
        return undefined;
    }
}
//# sourceMappingURL=web.js.map